import { ROUTE } from '../config';

export const getAuthRoute = (path: string) => {
  const nextParam = window.location.search.match(/next=([^&]+)/)?.[1];

  const formattedRoutePath = `${ROUTE}${path}`;
  const route = formattedRoutePath.endsWith('/') ? formattedRoutePath : `${formattedRoutePath}/`;

  if (nextParam) {
    return `${route}?next=${nextParam}`;
  }
  return route;
};
